import axiosClient from "../axiosClient";

const getToken = () => {
  return (
    (localStorage?.auth && JSON.parse(localStorage.auth)?.accessToken) ||
    undefined
  );
};

const getNCCReport = (params, thunkAPI) => {
  return axiosClient.get("reporting/tab-report", {
    signal: thunkAPI?.signal,
    params,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
};

const exportNCCReport = (params, options) => {
  return axiosClient.get("reporting/tab-report-export", {
    params,
    ...options,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    responseType: "blob",
  });
};

export { getNCCReport, exportNCCReport };
